export enum accountMergingActions {
  PUSH = 'accountMerging/push',
  REPLACE = 'accountMerging/replace',
  SET_PREVIOUS_PAGE_NAME = 'accountMerging/setPreviousPageName',
  CHECK_EXISTENCE = 'accountMerging/CheckExistence',
  UPDATE_STEP = 'accountMerging/updateStep',
  SEND_MERGE_OTP = 'accountMerging/sendMergingOtp',
  VERIFY_MERGE_OTP = 'accountMerging/verifyMergingOtp',
  RESEND_MERGE_OTP = 'accountMerging/resendMergingOtp',

}

export const recaptchaActions = {
  SEND_OTP: 'sendOtp',
  REGISTER: 'register',
  LOGIN: 'login',
  CHECK_EXISTENCE: 'checkExistence',
};

